module.exports = __webpack_public_path__ + "img/20190806162824709.b44d0a05.png";